var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E11F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 14.3333C22.6673 19.3333 16.0007 24.3333 16.0007 24.3333C16.0007 24.3333 9.33398 19.3333 9.33398 14.3333C9.33398 12.5652 10.0364 10.8695 11.2866 9.61925C12.5368 8.369 14.2325 7.66663 16.0007 7.66663C17.7688 7.66663 19.4645 8.369 20.7147 9.61925C21.9649 10.8695 22.6673 12.5652 22.6673 14.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.8334C17.3807 16.8334 18.5 15.7141 18.5 14.3334C18.5 12.9527 17.3807 11.8334 16 11.8334C14.6193 11.8334 13.5 12.9527 13.5 14.3334C13.5 15.7141 14.6193 16.8334 16 16.8334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.7fe1fcce0adec07c17896390015c8821.svg";
export { ForwardRef as ReactComponent };